import { render, staticRenderFns } from "./FormFillUpFee.vue?vue&type=template&id=2d6a75ec&"
import script from "./FormFillUpFee.vue?vue&type=script&lang=js&"
export * from "./FormFillUpFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports